import React from 'react'
import './Project.css'
import GitHubIcon from '@material-ui/icons/GitHub'

function Project({ img, title, info, link, github }) {
  return (
    <div className='project'>
      <a href={link} target='_blank' rel='noreferrer'>
        <img src={img} alt='' />
      </a>
      <div className='project__info'>
        <a href={link} target='_blank' rel='noreferrer'>
          {title}
        </a>
        <p>{info}</p>
        <a
          href={github}
          className='project__link'
          target='_blank'
          rel='noreferrer'
        >
          <GitHubIcon />
        </a>
      </div>
    </div>
  )
}

export default Project
